
import React from 'react';
import { Button } from '@/components/ui/button';
import { Sparkles } from 'lucide-react';

interface SuccessMessageProps {
  onUpdateInfo: () => void;
}

export const SuccessMessage: React.FC<SuccessMessageProps> = ({ onUpdateInfo }) => {
  return (
    <div className="text-center py-8 space-y-4">
      <div className="bg-green-50 rounded-full w-16 h-16 flex items-center justify-center mx-auto">
        <Sparkles className="h-8 w-8 text-hormony-coral" />
      </div>
      <h3 className="text-xl font-semibold">You're on the list!</h3>
      <p className="text-gray-600">
        Thank you for joining! We'll notify you when early access is available.
      </p>
      <Button 
        variant="outline" 
        className="mt-4"
        onClick={onUpdateInfo}
      >
        Update Information
      </Button>
    </div>
  );
};
